import { ViewProps } from './interactive.constants';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentStartCover } from '../shared/component-parts';
import { getPrintImage } from '../shared/logic/get-print-image';

const InteractiveStaticPreview = (props: ViewProps) => {
  const stimulus = props.stimulusResourceProperties;

  const { style, setContainerElement } = useContainerDimensions({
    aspectRatio: 16 / 9,
  });

  return stimulus ? (
    <ComponentAspectRatio dimensions={props.properties.dimensionData}>
      <ComponentAbsoluteWrapper ref={setContainerElement}>
        <ComponentStartCover
          type={props.type}
          buttonLabel="Start"
          resourceName={stimulus?.resourceName || ''}
          backgroundImage={
            stimulus.xlCoverImageUrls?.length
              ? getPrintImage(stimulus.xlCoverImageUrls || null)
              : stimulus?.coverImage?.original
          }
          style={style}
          data-selector="btn-start"
        />
      </ComponentAbsoluteWrapper>
    </ComponentAspectRatio>
  ) : null;
};

export default InteractiveStaticPreview;
